/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Funnel_Step_CheckoutInputs */

const en_admin_funnel_step_checkout = /** @type {(inputs: Admin_Funnel_Step_CheckoutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent to payment`)
};

/**
* | output |
* | --- |
* | "Sent to payment" |
*
* @param {Admin_Funnel_Step_CheckoutInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_funnel_step_checkout = /** @type {((inputs?: Admin_Funnel_Step_CheckoutInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Funnel_Step_CheckoutInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_funnel_step_checkout(inputs)
});
export { admin_funnel_step_checkout as "admin.funnel.step.checkout" }